export const parseSystemDesignPayload = (values: any) => ({
  ...values,
  inverters: values.inverterModels
    ?.map((inverter: { model: string; count: number; vintage?: string; avlItemId?: string }) => {
      if (!values.inverterManufacturer || !inverter.model) return undefined;
      return {
        manufacturer: values.inverterManufacturer,
        model: inverter.model,
        count: inverter.count || 1,
        vintage: inverter.vintage,
        avlItemId: inverter.avlItemId,
      };
    })
    .filter(Boolean),
  inverterManufacturer: undefined, // clear out deprecated field
  inverterModels: undefined, // clear out deprecated field
  firstYearMonthlyProductionKwh: values.firstYearMonthlyProductionKwh.map((value: string, index: number) => ({
    month: index + 1,
    productionKwh: Number(value),
  })),
  arrays: values.arrays.map((array: any) => ({
    ...array,
    monthlySolarAccess: array.monthlySolarAccess?.map((value: string, index: number) => ({
      month: index + 1,
      accessPercent: Number(value),
    })),
    inverter: array.inverter ? array.inverter - 1 : null,
  })),
  storage: values.storageModels
    ?.map((storage: { model: string; count: number; vintage?: string; avlItemId?: string }) => {
      if (!values.storageManufacturer || !storage.model) return undefined;
      return {
        manufacturer: values.storageManufacturer,
        model: storage.model,
        count: storage.count || 1,
        vintage: storage.vintage,
        avlItemId: storage.avlItemId,
      };
    })
    .filter(Boolean),
  storageModels: undefined, // clear out deprecated field
  storageManufacturer: undefined, // clear out deprecated field
});
